import { DateTime } from 'luxon';
import { Maybe, isDefined } from 'dg-web-shared/lib/MaybeV2.ts';

export const toDateConstraint = (
    fromDate: DateTime,
    toDate: Maybe<DateTime>,
) => (isDefined(toDate) && toDate < fromDate ? fromDate : toDate);

export const fromDateConstraint = (
    toDate: DateTime,
    fromDate: Maybe<DateTime>,
) => (isDefined(fromDate) && fromDate > toDate ? toDate : fromDate);
